module.exports = __webpack_public_path__ + "static/img/xc.45e4978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xc.png
// module id = yRq0
// module chunks = 0